import api from '@/utils/api'

class DashboardService {
  constructor() {
    this.BASE_URL = '/api/accounts/v2/dashboard'
  }

  /**
   * 获取邮件发送趋势数据
   * @param {number} days - 天数 (7, 30, 90)
   * @returns {Promise}
   */
  async getEmailTrend(days = 7) {
    try {
      const response = await api.get(`${this.BASE_URL}/email_trend/`, {
        params: { days }
      })
      return {
        success: true,
        data: response.data.data || response.data
      }
    } catch (error) {
      console.error('获取邮件趋势失败:', error)
      return {
        success: false,
        error: error.response?.data?.detail || '获取邮件趋势失败'
      }
    }
  }

  /**
   * 获取营销活动效果统计
   * @param {number} limit - 返回的活动数量
   * @returns {Promise}
   */
  async getCampaignStats(limit = 5) {
    try {
      const response = await api.get(`${this.BASE_URL}/campaign_stats/`, {
        params: { limit }
      })
      return {
        success: true,
        data: response.data.data || response.data
      }
    } catch (error) {
      console.error('获取营销活动统计失败:', error)
      return {
        success: false,
        error: error.response?.data?.detail || '获取营销活动统计失败'
      }
    }
  }

  /**
   * 获取客户增长趋势
   * @param {string} period - 统计周期 ('day', 'week', 'month')
   * @returns {Promise}
   */
  async getCustomerGrowth(period = 'month') {
    try {
      const response = await api.get(`${this.BASE_URL}/customer_growth/`, {
        params: { period }
      })
      return {
        success: true,
        data: response.data.data || response.data
      }
    } catch (error) {
      console.error('获取客户增长数据失败:', error)
      return {
        success: false,
        error: error.response?.data?.detail || '获取客户增长数据失败'
      }
    }
  }

  /**
   * 获取最近活动列表
   * @param {number} limit - 返回的活动数量
   * @returns {Promise}
   */
  async getRecentActivities(limit = 5) {
    try {
      const response = await api.get(`${this.BASE_URL}/recent_activities/`, {
        params: { limit }
      })
      return {
        success: true,
        data: response.data.data || response.data
      }
    } catch (error) {
      console.error('获取最近活动失败:', error)
      return {
        success: false,
        error: error.response?.data?.detail || '获取最近活动失败'
      }
    }
  }

  /**
   * 导出图表数据为 CSV
   * @param {Object} chartData - 图表数据
   * @param {string} filename - 文件名
   */
  exportToCSV(chartData, filename) {
    const { labels, datasets } = chartData
    
    // 构建 CSV 内容
    let csvContent = '日期'
    datasets.forEach(dataset => {
      csvContent += `,${dataset.label}`
    })
    csvContent += '\n'
    
    labels.forEach((label, index) => {
      csvContent += label
      datasets.forEach(dataset => {
        csvContent += `,${dataset.data[index]}`
      })
      csvContent += '\n'
    })
    
    // 创建下载链接
    const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' })
    const link = document.createElement('a')
    const url = URL.createObjectURL(blob)
    
    link.setAttribute('href', url)
    link.setAttribute('download', `${filename}.csv`)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  /**
   * 导出图表为图片
   * @param {string} canvasId - Canvas 元素 ID
   * @param {string} filename - 文件名
   */
  exportToImage(canvasId, filename) {
    const canvas = document.getElementById(canvasId)
    if (!canvas) {
      console.error('Canvas not found')
      return
    }
    
    const link = document.createElement('a')
    link.download = `${filename}.png`
    link.href = canvas.toDataURL('image/png')
    link.click()
  }
}

export const dashboardService = new DashboardService()
export default dashboardService

